<div class="folder-ac-wrapper">
  <i class="material-icons-outlined notranslate folder-ac-icon">folder</i>
  <div class="folder-ac-field">
    <input class="folder-ac-input"
           [formControl]="searchControl"
           [matAutocomplete]="folderAuto"
           [placeholder]="placeholder"
           (input)="onInput()"
           (keydown.escape)="onEscape($event)"
           autocomplete="off">
    <button class="folder-ac-clear"
            type="button"
            [class.has-value]="searchControl.value"
            [attr.aria-label]="searchControl.value ? 'Clear folder search' : null"
            (click)="searchControl.value && clear()">
      <i class="material-icons-outlined notranslate">{{searchControl.value ? 'close' : 'search'}}</i>
    </button>
  </div>
</div>

<mat-autocomplete #folderAuto [displayWith]="displayFn" (optionSelected)="onSelected($event)" class="folder-ac-panel">
  <ng-container *ngFor="let folder of filteredOptions$ | async">
    <mat-option *ngIf="!isCreateItem(folder); else createOption"
                [value]="folder"
                class="folder-ac-option">
      <i [class]="(folder.outlinedIcon ? 'material-icons-outlined' : 'material-icons') + ' notranslate folder-ac-option-icon'"
         [style.color]="folder.colour">{{folder.icon}}</i>
      <span class="folder-ac-option-name"
            [appTooltipOnTruncate]="folder.name"
            tooltipPosition="right">{{folder.name}}</span>
    </mat-option>
    <ng-template #createOption>
      <mat-option [value]="folder" class="folder-ac-option folder-ac-option--create"
                  [matTooltip]="'Create a new Folder named ' + folder.name"
                  matTooltipPosition="right"
                  [matTooltipShowDelay]="500">
        <i class="material-icons-outlined notranslate folder-ac-option-icon folder-ac-create-icon">create_new_folder</i>
        <span class="folder-ac-option-name">
          <span class="folder-ac-create-prefix">Create Folder</span>
          <span class="folder-ac-create-name">"{{folder.name}}"</span>
        </span>
      </mat-option>
    </ng-template>
  </ng-container>
  <mat-option *ngIf="showArchive && (showArchiveOption$ | async)"
              [value]="archiveOption"
              class="folder-ac-option folder-ac-option--archive">
    <i class="material-icons-outlined notranslate folder-ac-option-icon">inventory_2</i>
    <span class="folder-ac-option-name">Archive</span>
  </mat-option>
</mat-autocomplete>
